/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsEntryDownloadListResponse } from './RevisdomAPIViewModelsEntryDownloadListResponse';
import {
    RevisdomAPIViewModelsEntryDownloadListResponseFromJSON,
    RevisdomAPIViewModelsEntryDownloadListResponseFromJSONTyped,
    RevisdomAPIViewModelsEntryDownloadListResponseToJSON,
    RevisdomAPIViewModelsEntryDownloadListResponseToJSONTyped,
} from './RevisdomAPIViewModelsEntryDownloadListResponse';

/**
 * API yanıtları için genel response modeli
 * @export
 * @interface ApiResponse1DownloadListResponse
 */
export interface ApiResponse1DownloadListResponse {
    /**
     * İşlemin başarılı olup olmadığını belirtir
     * @type {boolean}
     * @memberof ApiResponse1DownloadListResponse
     */
    success?: boolean;
    /**
     * İşlem sonucu hakkında bilgi mesajı
     * @type {string}
     * @memberof ApiResponse1DownloadListResponse
     */
    message?: string | null;
    /**
     * 
     * @type {RevisdomAPIViewModelsEntryDownloadListResponse}
     * @memberof ApiResponse1DownloadListResponse
     */
    data?: RevisdomAPIViewModelsEntryDownloadListResponse;
    /**
     * Hata durumunda hata detayları
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ApiResponse1DownloadListResponse
     */
    errors?: { [key: string]: Array<string>; } | null;
}

/**
 * Check if a given object implements the ApiResponse1DownloadListResponse interface.
 */
export function instanceOfApiResponse1DownloadListResponse(value: object): value is ApiResponse1DownloadListResponse {
    return true;
}

export function ApiResponse1DownloadListResponseFromJSON(json: any): ApiResponse1DownloadListResponse {
    return ApiResponse1DownloadListResponseFromJSONTyped(json, false);
}

export function ApiResponse1DownloadListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResponse1DownloadListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : RevisdomAPIViewModelsEntryDownloadListResponseFromJSON(json['data']),
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function ApiResponse1DownloadListResponseToJSON(json: any): ApiResponse1DownloadListResponse {
    return ApiResponse1DownloadListResponseToJSONTyped(json, false);
}

export function ApiResponse1DownloadListResponseToJSONTyped(value?: ApiResponse1DownloadListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'message': value['message'],
        'data': RevisdomAPIViewModelsEntryDownloadListResponseToJSON(value['data']),
        'errors': value['errors'],
    };
}

